module.exports = __webpack_public_path__ + "static/media/tallbirdegg.fd8b30dc.webp";